import { IEstablishmentUser } from './IEstablishmentUser.interface';
import { IOpuUser } from './IOpuUser.interface';
import { IStudent } from './IStudent.interface';

enum EGender {
  MALE = 'M',
  FEMALE = 'F',
}

export interface IUser {
  id: string;

  firebase_uid?: string;

  firstName: string;

  lastName: string;

  email?: string; // Made optional for BAC matricule authentication

  phone?: string;

  gender?: EGender;

  creationDate: Date;

  // New fields for BAC matricule authentication
  bac_year?: string;
  bac_matricule?: string;
  birth_date?: Date;
  is_default_password?: boolean;
  isVerified?: boolean;

  opuUser?: IOpuUser;

  establishmentUser?: IEstablishmentUser;

  student?: IStudent;
}
